/* Action Types */
export const HYDRATE_CLIENT_STATE = 'HYDRATE_CLIENT_STATE';

/* ACTION CREATORS */
export const hydrateClientState = (params: any) => ({
    payload: { ...params },
    type: HYDRATE_CLIENT_STATE,
});
